import { gql } from '@apollo/client';

export const GET_PARTICIPANTS = gql`
  query GetParticipants($input: ParticipantsQuery) {
    participants(input: $input) {
      data {
        id
        proceedingId
        receiptRequestDate
        decisionIssueDate
        applicantBaId
        partyName
        type
        otherParticipantTypeDescription
        comments
        socFiler                
      }
    }
  }
`;

export const DELETE_PARTICIPANT = gql`
  mutation DeleteParticipant($input: ParticipantQuery) {
    deleteParticipant(input: $input) {
      result
      errorMessage
    }
  }
`;

export const GET_PARTICIPANT = gql`
  query GetParticipantDetail($input: ParticipantQuery) {
    participant(input: $input) {
      receiptRequestDate
      decisionIssueDate
      applicantBaId
      partyName
      type
      otherParticipantTypeDescription
      comments
      id
      proceedingId
      socFiler
    }
  }
`;

export const ADD_PARTICIPANT_MUTATION = gql`
  mutation AddParticipant($input: Participant) {
    addParticipant(input: $input) {
      result
    }
  }
`;

export const UPDATE_PARTICIPANT = gql`
  mutation UpdateParticipant($input: UpdateParticipantDetail) {
    updateParticipant(input: $input) {
      result
    }
  }
`;

export const GET_UNIQUE_PARTIES = gql`query UniqueParties($input: String) {
  uniqueParties(input: $input) {
    partyName
    participantId
  }
}`;